import * as React from 'react';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import PageContent from '../../components/layout/PageContent';
import { handleFormImageUpload } from '../../utils'
import CustomForm from '../../components/form/CustomForm';

const EditNotification = ({
	location: { state: { id = null } = {} } = {},
}) => {

	const [ fields, setFields ] = React.useState([]);

	const history = useHistory();

	React.useEffect(() => {
		axios.get(`/api/notification/${id}`)
		.then(({ data = {} }) => {
			const { result = { } } = data;
			const responseFields = (result?.data ?? []).map((field) => {
				if (["senderAvatarURL", "iconImageURL", "extendedImageURL"].includes(field.key)) {
					return {
						...field,
						value: [{
							url: field?.value || null,
						}]
					};
				}

				return {
					...field,
				};
			});
			setFields(responseFields);
		})
		.catch(err => {
			console.log(err);
		})
	}, [id]);

	const handleSubmit = (fields) => {
		axios.post(`/api/notification/${id}`, fields)
		.then(({ data }) => {
			if (data.statusCode === 200) {
				history.push('/notification');
			}
		})
		.catch(err => {
			console.log(err);
		})
	}

	const handleCancel = () => {
		history.push('/notification')
	};

	return (
		<PageContent
			background='#ffffff'
			subheader={{
				title: 'Сонордуулгын мэдээлэл засах',
				background: '#ffffff'
			}}
		>
			<CustomForm
				fields={fields}
				onSubmit={handleSubmit}
				onCancel={handleCancel}
				imageUpload={handleFormImageUpload}
			/>
		</PageContent>
	)
}

export default EditNotification;